module.exports = {
      id: "11aa5ec1e4e425406ab2c7a2b0776947roofShape-half-hip.svg-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "sprite.svg#11aa5ec1e4e425406ab2c7a2b0776947roofShape-half-hip.svg",
      toString: function () {
        return this.url;
      }
    }